import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import moment from 'moment'
import { isEmpty } from 'ramda'
import { push } from 'react-router-redux'
import { withRouter } from 'react-router'
import { Colors, Table, TableCell, TableExpander, TableHeader } from 'advenio-components'
import { Form } from 'formsy-react'
import PropTypes from 'prop-types'

import CenterOptionsActions from '../../Data/Redux/CenterOptionsRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import CompaniesActions from '../../Data/Redux/CompaniesRedux'
import ConsumbalesActions from '../../Data/Redux/ConsumablesRedux'
import ConsumbalesCategoriesActions from '../../Data/Redux/ConsumablesCategoriesRedux'
import CountriesActions from '../../Data/Redux/CountriesRedux'
import EmergencyMedicationsActions from '../../Data/Redux/EmergencyMedications'
import HealthCheckActions from '../../Data/Redux/HealthCheckRedux'
import IncidentTypesActions from '../../Data/Redux/IncidentTypes'
import InventoryActions from '../../Data/Redux/InventoryRedux'
import MoodActions from '../../Data/Redux/Mood'
import NotificationsActions from '../../Data/Redux/NotificationsRedux'
import OverviewActions from '../../Data/Redux/OverviewRedux'
import ParentPaymentTypesActions from '../../Data/Redux/ParentPaymentTypesRedux'
import ProgramLevelsActions from '../../Data/Redux/ProgramLevelsRedux'
import RelationsActions from '../../Data/Redux/RelationsRedux'
import StudyProgramsActions from '../../Data/Redux/StudyProgramsRedux'

import ChildByClassroom from './ChildByClassroom'
import LoadingSpinner from '../../Components/LoadingSpinner'
import Subcomponent from './Subcomponent'
import Percentage from '../../Components/ReportsComponents/Percentage'

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  width: 100%;
`
const CenterContainer = styled.div`
  flex-direction: column;
  width: 90%;
  margin-top: 50px;
`
const Center = styled.span`
  margin-right: 20px;
  font-weight: bold;
  font-size: 20px;
`
const CenterTitle = styled(Form)`
  display: flex;
  align-items: center;
  height: 50px;
  width: 90%;
  margin-bottom: 10px;
`
const Info = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`
const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 150px;
  width: ${props => props.large ? '400px' : '180px'};
  margin-right: 5px;
  padding: 16px;
  background: #FFFFFF;
  border: 1px solid ${Colors.gray400};
  border-radius: 6px;
  box-shadow: 0 2px 10px 0 rgba(0,0,0, .1);

  &:last-child {
    margin-right: 0;
  }

  @media (max-width: 1024px) {
    width: ${props => props.large ? '300px' : '130px'};
  }
`
const TableContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  border: 1px solid ${Colors.gray400};
  border-radius: 6px;
  box-shadow: 0 2px 10px 0 rgba(0,0,0, .1);
`
const ReportCard = styled.div`
  display: flex;
  flex-direction: column;
  height: 300px;
  width: 800px;
  padding: 16px;
  background: #FFFFFF;
  border: 1px solid ${Colors.gray400};
  border-radius: 6px;
  box-shadow: 0 2px 10px 0 rgba(0,0,0, .1);

  @media (max-width: 1024px) {
    width: 600px;
  }
`
const PhoneCard = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #FFFFFF;
  height: 300px;
  width: 400px;
  border: 1px solid ${Colors.gray400};
  border-radius: 6px;
  box-shadow: 0 2px 10px 0 rgba(0,0,0, .1);

  @media (max-width: 1024px) {
    width: 300px;
  }
`
const MedicineCard = styled(PhoneCard)`
  height: 150px;
`
const PhoneContainer = styled.div`
  overflow-y: auto;
  height: 250px;
  width: 100%;
`
const MedicineContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 250px;
  width: 100%;
  align-items: center;
  color: ${Colors.gray400};
`
const TitleContainer = styled.div`
  padding: 16px;
`
const Line = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: 20px;
  background: ${props => props.isWhite ? '#FFFFFF' : Colors.gray200};
`
const PhoneName = styled.div`
  font-weight: bold;
  color: ${Colors.blueText};
`
const PhoneNumber = styled(PhoneName)`
  opacity: .5;
`
const CardTitle = styled.span`
  color: ${Colors.gray500};
  font-size: 14px;
  font-weight: bold;

  @media (max-width: 1024px) {
    font-size: 12px;
  }
`
const CardData = styled.span`
  color: ${Colors.blueText};
  font-size: 48px;
  font-weight: bold;

  @media (max-width: 1024px) {
    font-size: 36px;
  }
`

class DirectorView extends Component {
  componentWillMount() {
    const {
      getClassrooms,
      getCompanies,
      getConsumables,
      getConsumablesCategories,
      getCountries,
      getEmergencyMedications,
      getHealthCheckQuestions,
      getIncidentTypes,
      getInventoryItems,
      getMoods,
      getOverview,
      getParentPaymentTypes,
      getProgramLevels,
      getRelations,
      getStudyPrograms,
      history,
      user,
      companies,
    } = this.props
    
    const pageWasRefreshed = history.action === 'POP'

    getOverview()

    if (user && user.is_impersonating && !pageWasRefreshed) {
      getClassrooms({'basic':true,'students':true})
      getCompanies()
      getConsumables(user.center_id)
      getConsumablesCategories()
      getCountries()
      getEmergencyMedications()
      getHealthCheckQuestions()
      getIncidentTypes()
      getInventoryItems()
      getMoods()
      getParentPaymentTypes()
      getProgramLevels()
      getRelations()
      getStudyPrograms(user.center_id)
    }

    if (user && user.is_impersonating && companies.length > 0) {
      const country_name = companies[0].country
      const country_id = Number(user.country_id)
      if (!(country_id === 1 && country_name === 'Mexico') || !(country_id === 2 && country_name === 'Colombia')) {
        getCompanies()
      }
    }
  }

  renderPhoneNumbers = () => {
    const { overview } = this.props

    if (!overview.emergency_numbers) return <div />

    return overview.emergency_numbers.map((phoneNumber, index) => (
      <Line key={phoneNumber.id} isWhite={(index + 1) % 2 === 0}>
        <PhoneName>{phoneNumber.name}</PhoneName>
        <PhoneNumber>{phoneNumber.tel}</PhoneNumber>
      </Line>
    ))
  }

  renderTodaysDueMedications = () => {
    const { overview: { medications_due_today } } = this.props

    if (!medications_due_today || medications_due_today.length <= 0) {
      return <span>No hay medicamentos por aplicar hoy</span>
    }

    return medications_due_today.map((medication, index) => (
      <Line key={medication.id} isWhite={(index + 1) % 2 === 0} >
        <PhoneName>{medication.student.full_name}</PhoneName>
        <PhoneNumber>{moment(medication.apply_at, 'HH:mm:ss').format('hh:mm A')}</PhoneNumber>
      </Line>
    ))
  }

  render() {
    const { overview, loading } = this.props

    if (isEmpty(overview) || loading) return <LoadingSpinner />

    return (
      <Container>
        <CenterContainer>
          <CenterTitle>
            <Center>{`Resumen - ${overview.name} (${overview.abbreviation})`}</Center>
          </CenterTitle>
          <Info>
            <Card>
              <CardTitle>
                ACTIVOS
              </CardTitle>
              <CardData>
                {overview.active_count}
              </CardData>
              <Percentage />
            </Card>
            <Card>
              <CardTitle>
                CHECKED OUT
              </CardTitle>
              <CardData>
                {overview.checked_out_count}
              </CardData>
              <Percentage />
            </Card>
            <Card>
              <CardTitle>
                SALA DE SINTOMAS
              </CardTitle>
              <CardData>
                {overview.sick_room_count}
              </CardData>
              <Percentage />
            </Card>
            <Card>
              <CardTitle>
                CENTRO VIRTUAL
              </CardTitle>
              <CardData>
                {overview.virtual_center_count}
              </CardData>
              <Percentage />
            </Card>
            <MedicineCard>
              <TitleContainer>
                <CardTitle>
                  MEDICAMENTOS
                </CardTitle>
              </TitleContainer>
              <MedicineContainer>
                {this.renderTodaysDueMedications()}
              </MedicineContainer>
            </MedicineCard>
          </Info>
          <CenterTitle>
            <Center>El Centro</Center>
          </CenterTitle>
          <Info>
            <ReportCard>
              <CardTitle>
                NIÑOS POR SALA
              </CardTitle>
              <ChildByClassroom data={overview.classrooms} />
            </ReportCard>
            <PhoneCard>
              <TitleContainer>
                <CardTitle>
                  TELEFONOS DE EMERGENCIA
                </CardTitle>
              </TitleContainer>
              <PhoneContainer>
                {this.renderPhoneNumbers()}
              </PhoneContainer>
            </PhoneCard>
          </Info>
        </CenterContainer>
      </Container>
    )
  }
}

DirectorView.propTypes = {
  /** React router browser history information */
  history: PropTypes.object.isRequired,
  /** Overview data to be displayed on the dashboard */
  overview: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
  /** The authenticated User */
  user: PropTypes.object.isRequired,
  /** Companies available in current Country */
  companies: PropTypes.array.isRequired,

  /** Fetch a listing of all classrooms belonging to the current center */
  getClassrooms: PropTypes.func.isRequired,
  /** Fetch a listing of all companies */
  getCompanies: PropTypes.func.isRequired,
  /** Fetch a listing of all available consumables for the current center */
  getConsumables: PropTypes.func.isRequired,
  /** Fetch a listing of all available consumable categories */
  getConsumablesCategories: PropTypes.func.isRequired,
  /** Fetch a listing of all available countries */
  getCountries: PropTypes.func.isRequired,
  /** Fetch a listing of all emergency medications due today at the current center */
  getEmergencyMedications: PropTypes.func.isRequired,
  /** Fetch a listing of all health check questions */
  getHealthCheckQuestions: PropTypes.func.isRequired,
  /** Fetch a listing of all incident types */
  getIncidentTypes: PropTypes.func.isRequired,
  /** Fetch a listing of all inventory items */
  getInventoryItems: PropTypes.func.isRequired,
  /** Fetch a listing of all moods that can be registered in the Checkout Inventory */
  getMoods: PropTypes.func.isRequired,
  /** Fetch the dashboard data for the current center */
  getOverview: PropTypes.func.isRequired,
  /** Fetch a listing of all available payment types */
  getParentPaymentTypes: PropTypes.func.isRequired,
  /** Fetch a listing of all available study program levels at the current center */
  getProgramLevels: PropTypes.func.isRequired,
  /** Fetch a listing of all available relations (Mother, Auntie, Grandma etc.) */
  getRelations: PropTypes.func.isRequired,
  /** Fetch a listing of all available study programs at the current center */
  getStudyPrograms: PropTypes.func.isRequired,
}

const mapStateToProps = ({ overview, auth, companies }) => ({
  overview: overview.get.results,
  loading: overview.get.fetching,
  user: auth.user,
  companies: companies.get.results,
})

const mapDispatchToProps = dispatch => ({
  getCenterOptions: () => dispatch(CenterOptionsActions.getRequest()),
  getClassrooms: (query) => dispatch(ClassroomActions.getRequest(query, true)),
  getCompanies: () => dispatch(CompaniesActions.getRequest({}, true)),
  getConsumables: centerId => dispatch(ConsumbalesActions.getRequest(centerId)),
  getConsumablesCategories: () => dispatch(ConsumbalesCategoriesActions.getRequest()),
  getCountries: () => dispatch(CountriesActions.getRequest()),
  getEmergencyMedications: () => dispatch(EmergencyMedicationsActions.getRequest()),
  getHealthCheckQuestions: () => dispatch(HealthCheckActions.getRequest()),
  getIncidentTypes: () => dispatch(IncidentTypesActions.getRequest()),
  getInventoryItems: () => dispatch(InventoryActions.getRequest()),
  getNotificationsTypes: () => dispatch(NotificationsActions.getRequest()),
  getOverview: () => dispatch(OverviewActions.getRequest()),
  getMoods: () => dispatch(MoodActions.getRequest()),
  getParentPaymentTypes: () => dispatch(ParentPaymentTypesActions.getRequest()),
  getProgramLevels: () => dispatch(ProgramLevelsActions.getRequest()),
  getRelations: () => dispatch(RelationsActions.getRequest()),
  getStudyPrograms: centerId => dispatch(StudyProgramsActions.getRequest(centerId,true)),
  goTo: link => dispatch(push(link)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DirectorView))



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/DirectorView.jsx